import { render, staticRenderFns } from "./YearTable.vue?vue&type=template&id=35e1fddc&scoped=true"
import script from "./YearTable.vue?vue&type=script&lang=js"
export * from "./YearTable.vue?vue&type=script&lang=js"
import style0 from "./YearTable.vue?vue&type=style&index=0&id=35e1fddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1fddc",
  null
  
)

export default component.exports